<template>
  <div>
    <Header></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 no-overflow ms-3 me-3 pt-3" style="position: relative;">
        <h2>Coupons</h2>
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex justify-content-between align-items-center">
            <a role="button" class="procricket-btn mb-3" @click="redirectToCreate">Create New Entry</a>
          </div>
          <input type="text" class="form-control mb-3" placeholder="Search in coupons..." v-model="searchText" style="width: 20%; position: relative; ">
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
            <tr>
              <th class="col-1" @click="toggleSort('couponId')">Coupon Id</th>
              <th class="col-1" @click="toggleSort('couponCode')">Coupon Code </th>
              <th class="col-1" @click="toggleSort('percentage')">Percentage</th>
              <th class="col-1" @click="toggleSort('active')">Active</th>
              <th class="col-1" @click="toggleSort('status')">Status</th>
              <th class="col-1" @click="toggleSort('updated')">Updated</th>

              <th class="col-1">Edit</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="config in sortData" :key="config.couponId">
              <td class="col-1 text-truncate" v-html="truncateText(config.couponId, 30)" @click="selectText" :data-text="config.couponId"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.couponCode, 30)" @click="selectText" :data-text="config.couponCode"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.percentage, 30)" @click="selectText" :data-text="config.percentage"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.active, 30)" @click="selectText" :data-text="config.active"></td>
              <td class="col-1 text-truncate" v-html="truncateText(config.status, 30)" @click="selectText" :data-text="config.status"></td>
              <td class="col-1 text-truncate" v-html="functions.formatUnixTimestamp(config.updated)" @click="selectText" :data-text="config.updated"></td>
              <td class="col-1 centered">
                <router-link :to="{ name: 'CouponEdit', params: { id: config.couponId, ...config } }" class="procricket-btn">
                  Edit
                </router-link>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import AdminService from "@/services/admin-service";
import Header from "@/components/Header.vue";
import functions from "@/functions";

export default {
  name: "Coupons",
  components: {
    Header,
  },
  data() {
    return {
      searchText: '',
      CouponsList: [],
      sortColumn: '',  // Add this property
      sortDirection: 'asc',
    };
  },
  computed: {
    functions() {
      return functions
    },
    filteredCouponsList() {
      const search = this.searchText.toLowerCase().trim();
      let filteredList = this.CouponsList.filter((config) => {
        return (
            (config.couponId && config.couponId.toString().includes(search)) ||
            (config.couponCode && config.couponCode.toLowerCase().includes(search)) ||
            (config.percentage && config.percentage.toString().includes(search)) ||
            (config.active && config.active.toString().includes(search)) ||
            (config.status && config.status.toString().includes(search)) ||
            (config.updated && config.updated.toString().includes(search)) // Assuming updated is a date field
        );
      });

      if (this.sortColumn) {
        const direction = this.sortDirection === 'asc' ? 1 : -1;
        filteredList = filteredList.sort((a, b) => {
          const valueA = a[this.sortColumn];
          const valueB = b[this.sortColumn];

          if (valueA < valueB) return -1 * direction;
          if (valueA > valueB) return 1 * direction;
          return 0;
        });
      }
      return filteredList;
    },
    sortData() {
      return this.filteredCouponsList;
    },
  },
  created() {
    this.doLoadPlans();
    document.addEventListener('click', (event) => this.handleClickAnywhere(event));

    this.sortColumn = 'couponId';
  },
  methods: {
    doLoadPlans() {
      AdminService.getCouponsList().then((data) => {
        this.CouponsList = data;
      }).catch((error) => {
        console.error("Error loading coupons:", error);
      });
    },
    wrapText(text, limit) {
      if (text.length > limit) {
        const firstLine = text.substring(0, limit);
        const secondLine = text.substring(limit);
        return `${firstLine}<br>${secondLine}`;
      } else {
        return text;
      }
    },
    truncateText(text, limit) {
      return text.length > limit ? text.substring(0, limit) + '...' : text;
    },
    redirectToCreate() {
      this.$router.push({ name: 'CouponCreate' }); // Navigate to the StripeEdit route without params
    },
    async selectText(event) {
      const originalText = event.target.getAttribute('data-text');
      try {
        await navigator.clipboard.writeText(originalText);
        this.highlightElement(event.target);
      } catch (err) {
        console.error('Failed to copy text: ', err);
      }
    },
    highlightElement(element) {
      this.removeHighlight();
      element.style.backgroundColor = 'yellow'; // Add highlight
      this.highlightedElement = element;
      setTimeout(this.removeHighlight, 10000); // Remove highlight after 10 seconds
    },
    removeHighlight() {
      if (this.highlightedElement) {
        this.highlightedElement.style.backgroundColor = ''; // Remove highlight
        this.highlightedElement = null;
      }
    },
    handleClickAnywhere() {
      this.removeHighlight()
    },
    toggleSort(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }
    },
  },
};
</script>
<style src="../../assets/style.css">
</style>
